const BLOCKER_MODALS_TYPE = {
  NEARPOD_MATH_EXCLUSIVE: 'NEARPOD_MATH_EXCLUSIVE',
  CENTURY_21_BRAIN_BREAKS_EXCLUSIVE: 'CENTURY_21_BRAIN_BREAKS_EXCLUSIVE',
  DRAG_AND_DROP_GOLD_EXCLUSIVE: 'DRAG_AND_DROP_GOLD_EXCLUSIVE',
  COLLABORATE_PREMIUM_EXCLUSIVE: 'COLLABORATE_PREMIUM_EXCLUSIVE',
  DESMOS_TEACH_ONLY: 'DESMOS_TEACH_ONLY',
  FLOCABULARY_TEACH_ONLY: 'FLOCABULARY_TEACH_ONLY',
  CLASSIC_SLIDES_TEACH_ONLY: 'CLASSIC_SLIDES_TEACH_ONLY',
  BOARDWORKS_TEACH_ONLY: 'BOARDWORKS_TEACH_ONLY',
  ACTIVITY_UNAVAILABLE: 'ACTIVITY_UNAVAILABLE',
  GOLD_ACTIVITY_EXCLUSIVE: 'GOLD_ACTIVITY_EXCLUSIVE'
};

export { BLOCKER_MODALS_TYPE };
//# sourceMappingURL=index.js.map
